import React, { ReactFragment } from "react";
import {
  Box,
  createStyles,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Theme,
} from "@material-ui/core";

interface IProps {
  headers: string[];
  children: ReactFragment;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      backgroundColor: theme.palette.secondary.light,
    },
    container: {
      marginTop: 20,
      width: "99%",
    },
  })
);

const Basket: React.FC<IProps> = ({ headers, children }: IProps) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Box className={classes.container}>
        <Table>
          <TableHead className={classes.header}>
            <TableRow>
              {headers.map((item: string) => (
                <TableCell key={item} align="center" style={{ color: "#fff" }}>
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>{children}</TableBody>
        </Table>
      </Box>
    </React.Fragment>
  );
};

export default Basket;
